export default "__VITE_ASSET__DGOVvjAL__"